import React from 'react';
import {
    NavLink,
    Link
  } from 'react-router-dom'

import Header from './inc/Header';
import Loader from './inc/Loader';
import Menu from './inc/Menu';


import { fetchMenu } from "./../actions/menuActionCreators";
import ScrollToTop from './inc/ScrollToTop';

class NoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true
        }
    }
    componentWillMount() {
		let before = performance.now();
		let _this = this;
		Promise.all([
			this.props.dispatch(fetchMenu('menu')),
		]).then(() => {
			let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					pageLoading: false
				})
			}
			
		});
	}

    render() {
        let _this = this;

        return (
			<main className="site__error" >
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header {..._this.props}/>
                <section className="site-error">
                    <div className="main-container">
                        <div className="inner-container">
                            <h5 className="font-lg">404</h5>
                            <p className="desc">The page you are looking for was removed or might never existed.</p>
                            <p className="font-md"><NavLink to={`${process.env.PUBLIC_URL}/`}>Go to Home Page</NavLink></p>
                        </div>
                    </div>
                </section>
				<Menu {..._this.props} />
			</main>
        );
    }
}

export default NoPage;


// WEBPACK FOOTER //
// ./src/components/NoPage.js